// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__z7Hfo","rotation":"loader_rotation__9RL6Q"};